import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["minHeight"];
/** @jsx jsx */
import React, { forwardRef } from 'react';
import { jsx } from '@emotion/react';
import { minHeightComponentStyles } from './styled';
export var MinHeightContainer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var minHeight = _ref.minHeight,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx("div", _extends({
    ref: ref,
    css: minHeightComponentStyles
  }, props, {
    style: _defineProperty({}, '--link-picker-min-height', minHeight)
  }));
});